import {
  Modal,
  ModalBody,
  Box,
  Text,
  List,
  ListItem,
  ModalHeader,
  ModalFooter,
  Button,
} from '@razorpay/blade/components';
import React from 'react';
import { ToggleLoanCategoryStatusConfirmationModalProps } from '../types';

export const ToggleLoanCategoryStatusConfirmationModal = ({
  isOpen,
  onClose,
  categoryName,
  modalType,
  onPrimaryButtonClick,
  isLoading,
  isDisabled,
}: ToggleLoanCategoryStatusConfirmationModalProps) => {
  const getModalBodyContent = (type: 'enable' | 'disable') => {
    switch (type) {
      case 'disable':
        return (
          <>
            <Text size={'medium'} variant="body" weight="regular">
              When you disable this category:
            </Text>
            <List>
              <ListItem>Active loans continue normally.</ListItem>
              <ListItem>Pending requests will be rejected.</ListItem>
              <ListItem>Employees can’t submit new requests.</ListItem>
            </List>
            <Text size={'medium'} variant="body" weight="regular">
              You can re-enable this category anytime for employees.
            </Text>
          </>
        );
      case 'enable':
      default:
        return (
          <>
            <Text size={'medium'} variant="body" weight="regular">
              When you enable this category:
            </Text>
            <List>
              <ListItem>Employees can submit new requests.</ListItem>
              <ListItem>The category appears in the employee portal.</ListItem>
              <ListItem>Existing loans remain unaffected.</ListItem>
            </List>
            <Text size={'medium'} variant="body" weight="regular">
              You can disable this category anytime for employees.
            </Text>
          </>
        );
    }
  };

  return (
    <Modal isOpen={isOpen} onDismiss={onClose}>
      <ModalHeader title={`${modalType === 'enable' ? 'Enable' : 'Disable'} ${categoryName}`} />
      <ModalBody>
        <Box display="flex" flexDirection="column" gap="spacing.3">
          {getModalBodyContent(modalType)}
        </Box>
      </ModalBody>
      <ModalFooter>
        <Box display="flex" justifyContent="space-around" gap="spacing.3">
          <Button
            onClick={onClose}
            variant="tertiary"
            isLoading={isLoading}
            isDisabled={isDisabled}
            isFullWidth>
            Cancel
          </Button>
          <Button
            isFullWidth
            color={modalType === 'enable' ? 'primary' : 'negative'}
            onClick={onPrimaryButtonClick}
            isLoading={isLoading}
            isDisabled={isDisabled}>
            {' '}
            {modalType === 'enable' ? 'Enable Now' : 'Disable Now'}{' '}
          </Button>
        </Box>
      </ModalFooter>
    </Modal>
  );
};
